import { DigitalTwin } from "./DigitalTwin";
import DigitalTwinRepository from "./DigitalTwinRepository";

export default class DigitalTwinService {
  private readonly digitalTwinRepository: DigitalTwinRepository =
    new DigitalTwinRepository();

  async updateUploadDigitalTwin(
    neuralNetworkId: number | string,
    params: {
      h5File: File;
      hdhtFile: File;
    }
  ): Promise<any> {
    return await this.digitalTwinRepository.updateUploadDigitalTwin(
      neuralNetworkId,
      params
    );
  }

  async uploadDigitalTwin(params: {
    hydroTwinName: string;
    inputParameters: string;
    assetId: string;
    outputParam: string;
    inpId: number;
    inpName: string;
    objectType: string;
    objectModelId: string;
    h5File: File;
    hdhtFile: File;
  }): Promise<any> {
    return await this.digitalTwinRepository.uploadDigitalTwin(params);
  }

  async postDigitalTwin(
    data: any,
    infrastructureId: any,
    parameterId: any
  ): Promise<any> {
    return await this.digitalTwinRepository.postDigitalTwin(
      data,
      infrastructureId,
      parameterId
    );
  }

  async getDigitalTwins(
    infrastructureId: number | string,
    paramId: number | string,
    loading: boolean = true
  ): Promise<DigitalTwin[]> {
    const response = await this.digitalTwinRepository.getDigitalTwins(
      infrastructureId,
      paramId,
      loading
    );
    return response as DigitalTwin[];
  }

  async deleteDigitalTwin(neuralNetworkId: any, parameterId: any): Promise<boolean> {
    return await this.digitalTwinRepository.deleteDigitalTwin(neuralNetworkId, parameterId);
  }

  async getTestModel(neuralNetworkId: number | string): Promise<any> {
    return this.digitalTwinRepository.getTestModel(neuralNetworkId);
  }

  async setFavoriteModel(neuralNetworkId: number | string): Promise<boolean> {
    return this.digitalTwinRepository.setFavoriteModel(neuralNetworkId);
  }

  async getDefaultConfiguration(): Promise<any> {
    const response = await this.digitalTwinRepository.getDefaultConfiguration();
    return response;
  }

  async postConfiguration(params: {
    parameterId: Number | String;
    data: {
      inpId: Number;
      inpObjectId: Number;
      inpObjectType: Number;
    };
  }) {
    return await this.digitalTwinRepository.postConfiguration(params);
  }

  async getConfiguration({ paramId, type }: { paramId: Number; type: String }) {
    return await this.digitalTwinRepository.getConfiguration({ paramId, type });
  }
}
